<template>
    <SidebarChild :selected-item="value" :items="MenuItems" :focusActive="true" @selected="selectedItem" />
</template>
<script>
import SidebarChild from "../../../../components/Sidebar/SidebarChild.vue";
import MenuItems from "./MenuItems";
import { mapGetters, mapState } from "vuex";

export default {
    name: "ChatSidebar",
    components: {
        SidebarChild,
    },
    props: {
        value: {
            type: [String, Number],
            default: null,
        },
    },
    computed: {
        ...mapState({
            liveVisitorCount: (state) => state.visitor.liveVisitorCount,
            chatTotal: (state) => state.chat.stats.total,
            unreadMessages: (state) => state.team.unreadMessages.filter((chat) => chat.unreadCount > 0).length,
            chatbotLive: (state) => state.chat.stats.chatbot,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    data: () => ({
        MenuItems: MenuItems(this),
    }),
    mounted() {
        this.MenuItems = MenuItems(this);
    },
    methods: {
        selectedItem({ key }) {
            this.$emit("input", key);
        },
    },
    watch: {
        liveVisitorCount() {
            this.MenuItems = MenuItems(this);
        },
        chatTotal() {
            this.MenuItems = MenuItems(this);
        },
        unreadMessages() {
            this.MenuItems = MenuItems(this);
        },
        chatbotLive() {
            this.MenuItems = MenuItems(this);
        },
    },
};
</script>
